/* Tuck the header away on the way down, bring it back on the way up.
 *
 * Deliberately small and deliberately not on requestAnimationFrame. rAF has
 * bitten this theme three times — it starves in headless Chrome and in
 * throttled background tabs — and it buys nothing here: the work is one
 * scroll-offset read and one class toggle, which the browser already
 * coalesces to a frame for a passive scroll listener. Keeping it out of rAF
 * also means the harness can drive this by scrolling, not by faking a clock.
 *
 * The header is HELD VISIBLE, never tucked, whenever:
 *   · the page is still within FLOOR px of the top (over the hero it would
 *     read as a glitch, and there is nothing to gain — the bar is about to
 *     scroll off anyway),
 *   · the mobile menu <details> is open,
 *   · the cart drawer is open,
 *   · focus is inside the header — a keyboard user tabbing into a nav link
 *     must not be following an element that has slid off the screen.
 */
(() => {
  const hdr = document.querySelector('.hdr');
  if (!hdr) return;

  /* The sticky element is the section-group wrapper, not .hdr — see
     section-header.css. Fall back to .hdr so a template that renders the
     header outside a section group still works. */
  const bar = hdr.closest('.shopify-section-group-header-group') || hdr;

  const FLOOR = 220;   // px from the top of the document before tucking starts
  const STEP = 8;      // px of travel needed to count as a direction, kills jitter

  let last = window.scrollY;
  let held = false;

  const show = () => bar.classList.remove('is-tucked');
  const tuck = () => bar.classList.add('is-tucked');

  const blocked = () =>
    held ||
    hdr.contains(document.activeElement) ||
    !!hdr.querySelector('.hdr__menu[open]') ||
    !!document.querySelector('.drawer.is-open');

  const onScroll = () => {
    const y = window.scrollY;
    const moved = y - last;

    if (Math.abs(moved) < STEP) return;   // read the direction, not the noise
    last = y;

    if (y <= FLOOR || blocked()) { show(); return; }
    if (moved > 0) tuck(); else show();
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  /* Focus and the two open states are events, not scroll positions, so they
     get their own hold rather than waiting for the next scroll to correct. */
  hdr.addEventListener('focusin', show);
  hdr.addEventListener('toggle', () => { if (hdr.querySelector('.hdr__menu[open]')) show(); }, true);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) show();
  });

  /* An anchor jump lands the reader mid-page with no scroll direction to read.
     Hold the bar visible for one beat so they can see where they are. */
  window.addEventListener('hashchange', () => {
    held = true;
    show();
    setTimeout(() => { held = false; last = window.scrollY; }, 600);
  });
})();
